import * as React from 'react';
import { cn } from '@relay-towing/tokens';
import { frameRecipe, type FrameRecipeProps } from '../recipes/frame.recipe';

export interface FrameProps
  extends Omit<React.IframeHTMLAttributes<HTMLIFrameElement>, 'title'>,
    FrameRecipeProps {
  /**
   * Required: it is the only name a screen reader has for what is inside,
   * and the browser's own fallback is the URL.
   */
  title: string;
}

/**
 * An embedded document — a PDF, a published site, the studio preview.
 *
 *   <Frame src={pdfUrl} title={fileName} radius="lg" className="h-[70vh]" />
 *   <Frame srcDoc={html} sandbox="allow-scripts" title="Website Preview" />
 *   <Frame ref={iframeRef} title="Site preview" fill />
 *
 * `sandbox` and `allow` pass straight through: what the embedded page may do
 * is the site's decision. The ref is the iframe itself, for a caller that
 * measures it or portals into its document.
 */
export const Frame = React.forwardRef<HTMLIFrameElement, FrameProps>(
  function Frame({ fill, ratio, radius, className, ...props }, ref) {
    return (
      // design-tokens-ignore: owned by Frame
      <iframe
        ref={ref}
        className={cn(frameRecipe({ fill, ratio, radius }), className)}
        {...props}
      />
    );
  }
);
